module.exports = __webpack_public_path__ + "img/2.54df04f3.png";